import React, { useState } from 'react';
import './Download.css';
import Trial from './Trial';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faChartBar, faDatabase, faBoxOpen, faMobileAlt, faFileInvoice, faStore, faDownload } from '@fortawesome/free-solid-svg-icons';

const desktopFiles = [
  { name: 'Auditusierp v18.5.5.9', desc: 'Latest ERP desktop application', size: '56,160 KB', icon: faDesktop, path: '/Download/Downloads/Auditusierp18.5.5.9.rar', color: '#667eea' },
  { name: 'Report Tool v18.5', desc: 'Advanced report designer', size: '56,110 KB', icon: faChartBar, path: '/Download/Downloads/AuditusierReportTool 18.5.5.9.rar', color: '#f093fb' },
  { name: 'MySQL 8.0.31', desc: 'Database engine', size: '5,463 KB', icon: faDatabase, path: '/Download/Downloads/mysql 8.0.31.rar', color: '#4facfe' },
];

const mobileApps = [
  { name: 'AuditRack', desc: 'Stock audit & verification app', type: 'Android APK', icon: faBoxOpen, path: '/Download/Mobile_app/AuditRack.apk', color: '#43e97b' },
  { name: 'Auditusierp Mobile', desc: 'Full ERP on your phone', type: 'Android APK', icon: faMobileAlt, path: '/Download/Mobile_app/AuditusIerp-Mobileapp.apk', color: '#667eea' },
];

const gstFiles = [
  { name: 'GSTR-1', size: '3,398 KB', path: '/Download/GST/GSTR1.zip' },
  { name: 'GSTR-2', size: '1,135 KB', path: '/Download/GST/GSTR2.zip' },
  { name: 'GSTR-3B', size: '76 KB', path: '/Download/GST/GSTR3B.zip' },
  { name: 'GSTR-4', size: '6,931 KB', path: '/Download/GST/GSTR4.zip' },
  { name: 'GST ITC-04', size: '868 KB', path: '/Download/GST/GSTRITC04.zip' },
];

const backupFiles = [
  { name: 'Automobiles Shop', size: '357 KB', path: '/Download/Backup/Automobiles shop demo.rar' },
  { name: 'Computer & Hardware', size: '150 KB', path: '/Download/Backup/Computer and Hardware demo.rar' },
  { name: 'Footwear Shop', size: '131 KB', path: '/Download/Backup/Footwear shop demo.rar' },
  { name: 'Mobile Shop', size: '51 KB', path: '/Download/Backup/Mobile shop demo.rar' },
  { name: 'Pharma Agencies', size: '671 KB', path: '/Download/Backup/Pharma Agencies Demo.rar' },
  { name: 'Pharmacy Retail', size: '771 KB', path: '/Download/Backup/Pharmacyretail.rar' },
  { name: 'Plywood', size: '263 KB', path: '/Download/Backup/plywoodbackup.rar' },
  { name: 'Sanitary Shop', size: '157 KB', path: '/Download/Backup/Sanitary shop demo.rar' },
  { name: 'Supermarket', size: '955 KB', path: '/Download/Backup/Supermarket.rar' },
  { name: 'Textiles Shop', size: '266 KB', path: '/Download/Backup/Textiles shop demo.rar' },
];

const appInstructions = [
  'Click the Download button for your desired app.',
  'If prompted, allow downloads from this source in your browser.',
  'Once downloaded, open the APK file.',
  'If asked, enable installation from unknown sources in your device settings.',
  'Follow the on-screen instructions to complete installation.',
];

export default function Download() {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);

  const handleAppClick = (app) => { setSelectedApp(app); setShowPopup(true); };

  return (
    <div className="dl-root">
      {/* ── HERO ── */}
      <section className="dl-hero">
        <div className="dl-hero-orb dl-orb-1" />
        <div className="dl-hero-orb dl-orb-2" />
        <div className="dl-hero-inner">
          <div className="dl-hero-badge"><span className="dl-badge-dot" />Download Center</div>
          <h1 className="dl-hero-title">Get <span>Auditusierp</span><br />Software & Apps</h1>
          <p className="dl-hero-sub">Download the latest desktop software, mobile apps, GST report tools, and business templates — all in one place.</p>
        </div>
      </section>

      {/* ── DESKTOP SOFTWARE ── */}
      <section className="dl-section">
        <div className="dl-section-header">
          <span className="dl-tag">Desktop Software</span>
          <h2 className="dl-section-title">Windows Applications</h2>
          <p className="dl-section-sub">Download and install on your Windows PC</p>
        </div>
        <div className="dl-cards-grid">
          {desktopFiles.map((f, i) => (
            <div key={i} className="dl-card">
              <div className="dl-card-accent" style={{ background: f.color }} />
              <div className="dl-card-icon" style={{ background: `${f.color}22`, color: f.color }}><FontAwesomeIcon icon={f.icon} /></div>
              <h3>{f.name}</h3>
              <p className="dl-card-desc">{f.desc}</p>
              <span className="dl-card-size">{f.size}</span>
              <a href={f.path} download className="dl-card-btn" style={{ background: f.color }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg>
                Download
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* ── MOBILE APPS ── */}
      <section className="dl-section dl-section-alt">
        <div className="dl-section-header">
          <span className="dl-tag">Mobile Apps</span>
          <h2 className="dl-section-title">Android Applications</h2>
          <p className="dl-section-sub">Business on the go — download our mobile apps</p>
        </div>
        <div className="dl-cards-grid dl-cards-2">
          {mobileApps.map((app, i) => (
            <div key={i} className="dl-card dl-card-mobile" onClick={() => handleAppClick(app)}>
              <div className="dl-card-accent" style={{ background: app.color }} />
              <div className="dl-card-icon" style={{ background: `${app.color}22`, color: app.color }}><FontAwesomeIcon icon={app.icon} /></div>
              <h3>{app.name}</h3>
              <p className="dl-card-desc">{app.desc}</p>
              <span className="dl-card-badge">{app.type}</span>
              <button className="dl-card-btn" style={{ background: app.color }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg>
                Download APK
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* ── GST REPORTS ── */}
      <section className="dl-section">
        <div className="dl-section-header">
          <span className="dl-tag dl-tag-green">GST Reports</span>
          <h2 className="dl-section-title">GST Filing Templates</h2>
          <p className="dl-section-sub">Ready-to-use GST report formats</p>
        </div>
        <div className="dl-list">
          {gstFiles.map((f, i) => (
            <div key={i} className="dl-list-item dl-list-green">
              <div className="dl-list-left">
                <span className="dl-list-icon"><FontAwesomeIcon icon={faFileInvoice} /></span>
                <div><strong>{f.name}</strong><span className="dl-list-size">{f.size}</span></div>
              </div>
              <a href={f.path} download className="dl-list-btn dl-list-btn-green">Download</a>
            </div>
          ))}
        </div>
      </section>

      {/* ── BUSINESS TEMPLATES ── */}
      <section className="dl-section dl-section-alt">
        <div className="dl-section-header">
          <span className="dl-tag dl-tag-orange">Business Templates</span>
          <h2 className="dl-section-title">Industry Backup Files</h2>
          <p className="dl-section-sub">Pre-configured templates for various business types</p>
        </div>
        <div className="dl-list">
          {backupFiles.map((f, i) => (
            <div key={i} className="dl-list-item dl-list-orange">
              <div className="dl-list-left">
                <span className="dl-list-icon"><FontAwesomeIcon icon={faStore} /></span>
                <div><strong>{f.name}</strong><span className="dl-list-size">{f.size}</span></div>
              </div>
              <a href={f.path} download className="dl-list-btn dl-list-btn-orange">Download</a>
            </div>
          ))}
        </div>
      </section>

      {/* ── APP INSTALL POPUP ── */}
      {showPopup && selectedApp && (
        <div className="dl-popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="dl-popup" onClick={e => e.stopPropagation()}>
            <button className="dl-popup-close" onClick={() => setShowPopup(false)}>✕</button>
            <div className="dl-popup-icon"><FontAwesomeIcon icon={faMobileAlt} size="2x" /></div>
            <h3>Install {selectedApp.name}</h3>
            <p className="dl-popup-sub">Follow these steps to install on your Android device:</p>
            <ol className="dl-popup-steps">
              {appInstructions.map((s, i) => <li key={i}>{s}</li>)}
            </ol>
            <a href={selectedApp.path} download className="dl-popup-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg>
              Download {selectedApp.name}
            </a>
          </div>
        </div>
      )}

      <Trial />
    </div>
  );
}